<nav class="primary-navigation">

    <ng-container *ngIf="(isAdmin() || isModerator()) && isLoggedIn()">
        <div class="nav-section-label">Tables</div>
        <ul class="nav-list">
            <li *ngIf="isAdmin()"
                routerLink="/app/file-service" routerLinkActive="active"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-table"></i>
                    <span>File Service</span>
                </a>
            </li>

            <li routerLink="/app/pure-originals" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-table"></i>
                    <span>Pure Originals</span>
                </a>
            </li>

            <li routerLink="/app/stage-clusters" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-diagram-3"></i>
                    <span>Stage 1 Clusters</span>
                </a>
            </li>

            <li *ngIf="isAdmin()"
                routerLink="/app/master-database" routerLinkActive="active"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-table"></i>
                    <span>Master Database</span>
                </a>
            </li>

            <li *ngIf="isAdmin()"
                routerLink="/app/masters-results" routerLinkActive="active"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-table"></i>
                    <span>Masters Results</span>
                </a>
            </li>
        </ul>
    </ng-container>

    <ng-container *ngIf="isAdmin() && isLoggedIn()">
        <div class="nav-section-label">Automation</div>
        <ul class="nav-list">
            <li routerLink="/app/ai-finisher" routerLinkActive="active"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-robot"></i>
                    <span>AI Finisher</span>
                </a>
            </li>
        </ul>
    </ng-container>

    <ng-container *ngIf="isAdmin() && isLoggedIn()">
        <div class="nav-section-label">ECU</div>
        <ul class="nav-list">
            <li routerLink="/app/ecu-names/ecu-build-names" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-cpu"></i>
                    <span>ECU Builds</span>
                </a>
            </li>

            <li routerLink="/app/ecu-names/correct-ecu-producers" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-cpu"></i>
                    <span>ECU Producers</span>
                </a>
            </li>
            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                <a class="nav-link" routerLink="/app/ecu-names/detected-ecu-builds"
                   (click)="closeNavMenuAfterClickOnLink()">
                    <i class="bi bi-cpu"></i>
                    <span>Detected ECU Builds</span>
                </a>
            </li>
        </ul>
    </ng-container>

    <ng-container *ngIf="(isAdmin() || isSuperAdmin()) && isLoggedIn()">
        <div class="nav-section-label">Faulty</div>
        <ul class="nav-list">
            <li routerLink="/app/ecu-names/faulty-vehicle-data" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-exclamation-triangle"></i>
                    <span>Faulty Vehicle Data</span>
                </a>
            </li>

            <li *ngIf="isAdmin()"
                routerLink="/app/ecu-names/faulty-pure-originals" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-exclamation-triangle"></i>
                    <span>Faulty Pure Originals</span>
                </a>
            </li>

            <li *ngIf="isAdmin()"
                routerLink="/app/ecu-names/faulty-masters" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-exclamation-triangle"></i>
                    <span>Faulty Masters</span>
                </a>
            </li>

            <li routerLink="/app/ecu-names/faulty-ecu-builds" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-exclamation-triangle"></i>
                    <span>Faulty ECU Builds</span>
                </a>
            </li>
        </ul>
    </ng-container>

    <ng-container *ngIf="(isAdmin() || isSuperAdmin()) && isLoggedIn()">
        <div class="nav-section-label">Configuration</div>
        <ul class="nav-list">
            <li *ngIf="isAdmin()"
                routerLink="/app/tuning-wrapper-names/tuning-names" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-dash-circle"></i>
                    <span>Tuning Names</span>
                </a>
            </li>

            <li routerLink="/app/ecu-names/vehicle-producers-table" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-building"></i>
                    <span>Vehicle Producers</span>
                </a>
            </li>

            <li routerLink="/app/ecu-names/vehicle-types-table" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-car-front"></i>
                    <span>Vehicle Types</span>
                </a>
            </li>

            <li *ngIf="isAdmin()"
                routerLink="/app/tuning-wrapper-names/reseller-tuning-combinations" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-box"></i>
                    <span>Reseller Combinations</span>
                </a>
            </li>

            <li *ngIf="isAdmin()"
                routerLink="/app/custom-functions" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-sliders2"></i>
                    <span>Custom Functions</span>
                </a>
            </li>
        </ul>
    </ng-container>

    <ng-container *ngIf="isAdmin() && isLoggedIn()">
        <div class="nav-section-label">WinOLS</div>
        <ul class="nav-list">
            <li routerLink="/app/win-ols-customers" routerLinkActive="active"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-people"></i>
                    <span>Customers</span>
                </a>
            </li>

            <li routerLink="/app/winOls-transactions" routerLinkActive="active"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-arrow-left-right"></i>
                    <span>Transactions</span>
                </a>
            </li>
        </ul>

        <div class="nav-section-label">Solutions</div>
        <ul class="nav-list">
            <li routerLink="/app/win-ols-solutions-wrapper/win-ols-solutions-options-only" routerLinkActive="active"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-grid"></i>
                    <span>Options Only</span>
                </a>
            </li>

            <li routerLink="/app/win-ols-solutions-wrapper/win-ols-solutions-stage1-options" routerLinkActive="active"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-grid"></i>
                    <span>Stage 1 + Options</span>
                </a>
            </li>

            <li routerLink="/app/win-ols-solutions-wrapper/win-ols-solutions-stage2-options" routerLinkActive="active"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-grid"></i>
                    <span>Stage 2 + Options</span>
                </a>
            </li>

            <li routerLink="/app/win-ols-solutions-wrapper/win-ols-solutions-tcu-options" routerLinkActive="active"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-grid"></i>
                    <span>TCU Options</span>
                </a>
            </li>

            <li routerLink="/app/win-ols-solutions-wrapper/win-ols-solutions-tcu-tuning" routerLinkActive="active"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-grid"></i>
                    <span>TCU Tunings</span>
                </a>
            </li>

            <li routerLink="/app/win-ols-solutions-wrapper/win-ols-solutions-version-comments" routerLinkActive="active"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-grid"></i>
                    <span>Version Comments</span>
                </a>
            </li>
        </ul>

        <div class="nav-section-label">Analytics</div>
        <ul class="nav-list">
            <li routerLink="/app/statistics" routerLinkActive="active"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-graph-up-arrow"></i>
                    <span>Statistics</span>
                </a>
            </li>

            <li routerLink="/app/user-statistics" routerLinkActive="active"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-person-circle"></i>
                    <span>User Statistics</span>
                </a>
            </li>
        </ul>

        <div class="nav-section-label">System</div>
        <ul class="nav-list">
            <li routerLink="/app/admin-panel" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-person"></i>
                    <span>Admin Panel</span>
                </a>
            </li>

            <li routerLink="/app/email-notifications" routerLinkActive="active"
                (click)="closeNavMenuAfterClickOnLink()">
                <a class="nav-link">
                    <i class="bi bi-chat"></i>
                    <span>Email Notifications</span>
                </a>
            </li>
        </ul>
    </ng-container>

</nav>
